export const PY_DATA_REQUEST = 'PY_DATA_REQUEST';
export const PY_DATA_SUCCESS = 'PY_DATA_SUCCESS';
export const PY_DATA_FAIL = 'PY_DATA_FAIL';
